// WP-6.5 (M29 AD-5, LOCKED §2.36, S-32): "every recommendation shows reasoning, assumptions,
// key inputs, confidence, and trade-offs" — collapsed by default (S-32's own "[Why?] expander")
// so a suggestion/affordability card stays uncluttered until the owner asks for the reasoning.
import { useState } from 'react';
import type { WhySections } from '../lib/why';

function WhySection({ title, items }: { title: string; items: string[] }): React.JSX.Element {
  return (
    <div>
      <p className="font-medium text-ink">{title}</p>
      <ul className="list-disc pl-4 text-muted">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
}

export function WhyExpander({ sections }: { sections: WhySections }): React.JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-2">
      <button
        type="button"
        className="text-sm text-primary hover:underline"
        aria-expanded={open}
        onClick={() => {
          setOpen((o) => !o);
        }}
      >
        {open ? 'Hide why' : 'Why?'}
      </button>
      {open && (
        <div className="mt-2 space-y-2 rounded-[var(--radius-card)] border border-border bg-canvas p-3 text-sm">
          <WhySection title="Inputs" items={sections.inputs} />
          <WhySection title="Assumptions" items={sections.assumptions} />
          <div>
            <p className="font-medium text-ink">Confidence</p>
            <p className="text-muted">{sections.confidence}</p>
          </div>
          <WhySection title="Trade-offs" items={sections.tradeOffs} />
        </div>
      )}
    </div>
  );
}
